import React, { useState } from "react";
import NcImage from "images/FAQ.png";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
}) => {
  return (
    <div className={`my-4 border px-4 rounded-xl ${isOpen ? "border-primary-100" : "border-[#E5E7EB]"}`}>
      <button
        onClick={onToggle}
        className="flex justify-between w-full space-x-4  py-6 text-left items-center"
      >
        <span className={`text-lg font-semibold leading-7 text-left  ${isOpen ? "text-primary-100" : "text-[#121212]"}`}>
          {title}
        </span>
        <span>
          {isOpen ? (
            <svg
              width="18"
              height="11"
              viewBox="0 0 18 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.375 0.572266L16.9922 8.15039C17.3438 8.54102 17.3438 9.12695 16.9922 9.47852L16.0938 10.377C15.7422 10.7285 15.1562 10.7285 14.7656 10.377L8.75 4.36133L2.69531 10.377C2.30469 10.7285 1.71875 10.7285 1.36719 10.377L0.46875 9.47852C0.117188 9.12695 0.117188 8.54102 0.46875 8.15039L8.08594 0.572266C8.4375 0.220703 9.02344 0.220703 9.375 0.572266Z"
                fill="#FBBE06"
              />
            </svg>
          ) : (
            <svg
              width="18"
              height="11"
              viewBox="0 0 18 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.58594 10.272L0.96875 2.69385C0.617188 2.30322 0.617188 1.71729 0.96875 1.36572L1.86719 0.467285C2.21875 0.115723 2.80469 0.115723 3.19531 0.467285L9.25 6.48291L15.2656 0.467285C15.6562 0.115723 16.2422 0.115723 16.5938 0.467285L17.4922 1.36572C17.8438 1.71729 17.8438 2.30322 17.4922 2.69385L9.875 10.272C9.52344 10.6235 8.9375 10.6235 8.58594 10.272Z"
                fill="#121212"
              />
            </svg>
          )}
        </span>
      </button>
      {isOpen && <div className="px-4 py-2">{children}</div>}
    </div>
  );
};

const FAQ: React.FC = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenSectionIndex(openSectionIndex === index ? null : index);
  };
  return (
    <div>
      <h2 className="text-center mb-12 text-4xl font-bold">
        Frequently Asked Questions
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-8">
        <div className="flex max-w-lg flex-col space-y-10 justify-center self-start">
          <img className="w-full" src={NcImage} alt="" />
        </div>

        <div>
          <h2 className="text-4xl font-semibold max-w-lg">
            Everything you need to know about our services
          </h2>
          <Section
            title="What is the minimum age requirement for renting?"
            isOpen={openSectionIndex === 1}
            onToggle={() => handleToggle(1)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              21 for most vehicles, though our Runabout class is available to
              18+
            </span>
          </Section>

          <Section
            title="Is there a security deposit needed for rentals?"
            isOpen={openSectionIndex === 3}
            onToggle={() => handleToggle(3)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              There’s a refundable security deposit held in case of smoking,
              tolls, and other damage. It is typically refunded 24 hours after
              your trip ends.
            </span>
          </Section>
          <Section
            title=" Is there a minimum rental duration?"
            isOpen={openSectionIndex === 4}
            onToggle={() => handleToggle(4)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              Yes, 2 days on most cars, 3 days on Runabout class
            </span>
          </Section>
          <Section
            title="Do I need my own auto insurance to rent?"
            isOpen={openSectionIndex === 5}
            onToggle={() => handleToggle(5)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              You may use your own insurance or purchase insurance upon
              checkout.
            </span>
          </Section>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
